import { Typography } from '@mui/material';
import { ReactNode } from 'react';

type TeamSettingItemProps = {
  children: ReactNode;
  title: string;
  description?: string;
};

export const TeamSettingItem = ({
  children,
  title,
  description,
}: TeamSettingItemProps) => {
  return (
    <div className="rounded-lg border border-color-gray-300 p-5 flex flex-row justify-between">
      <div className="w-1/2">
        <Typography variant="h3" className="text-base">
          {title}
        </Typography>
        {description && (
          <Typography
            variant="body2"
            className="text-sm text-muted-foreground"
          >
            {description}
          </Typography>
        )}
      </div>
      <div className="w-1/2 flex justify-end items-center">{children}</div>
    </div>
  );
};

